import httpClient from "@/plugins/axios";

export const getTags = async () => {
    const response = await httpClient.get(`/v1/tags/`);
    return response;
}
